import { WorkTableEntry } from "./work_table_entry";

/**
 * WorkTable class
 */
export class WorkTable {

    public user_id: string;
    public work_time: Array<WorkTableEntry>;


    /**
     * @method constructor
     * @param user_id 
     * @param work_time 
     */
    constructor(user_id: string, work_time: Array<WorkTableEntry>) {
        this.user_id = user_id;
        this.work_time = work_time;
    }
}


// WEBPACK FOOTER //
// ./src/models/work_table.ts